import { render, staticRenderFns } from "./ConsumptionStructure.vue?vue&type=template&id=7833071d&"
import script from "./ConsumptionStructure.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionStructure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports